<template>
  <div class="subpage-container">
    <div class="docs">
      <h3 class="docs-title">{{ title }}</h3>
      <div v-for="(row, i) in content" :key="i" class="docs-container" :class="row.class">
        <p v-if="row.byline && row.type == 'img'" class="docs-byline">{{ row.byline }}</p>
        <p v-if="row.type == 'text'" class="docs-text">{{ row.content }}</p>
        <div v-if="row.type == 'img'" class="imgsingel">
        <img
          class="docs-img"
          loading="lazy"
          :class="row.imgClass"
          :src="getImg(row.content)"
        />
        </div>
        <div v-if="row.type == 'imggroup'" class="imggroup">
          <p v-if="row.byline" class="docs-byline group">{{ row.byline }}</p>
          <img
            class="docs-img"
            loading="lazy"
            :class="row.imgClass"
            v-for="(img, i) in row.content"
            :key="i"
            :src="getImg(img)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Timeline from './extra/Timeline.vue';

export default {
  components: {},
  name: "BilderDokumenter",
  props: {
    content: {
      type: Array,
    },
    title: {
      type: String,
      default: "Tittel",
    },
  },
  data() {
    return {};
  },
  methods: {
    shift(id) {
      if (id % 2) {
        return "right";
      } else {
        return "left";
      }
    },
    getImg(name) {
      return require("@/assets/extra/" + name);
    },
  }
};
</script>
<style lang="scss" scoped>
.docs {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-container {
    width: 100%;
    

  }
  &-title {
    color: color("white");
  }

  .imggroup {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: -80px;
    margin-top: 40px; 
  }
  .imgsingel {
    display: flex;
    flex-direction: column;
    align-items: center;

  }

   .rotate:nth-child(even) {
      transform: rotate(2deg);
    }

    .rotate:nth-child(odd) {
      transform: rotate(-2deg);
    }

    .rotate-odd {
      transform: rotate(2deg);
    }
    .mt {
      margin-top: 100px;
    }

  &-img {
    width: 300px;
    height: auto;
   
    //max-height: 80%;
    @include desktop() {
      width: 400px;
    }
    margin: 8px;
    filter: drop-shadow(5px 5px 5px #222);
    
   

    &.border {
      // border: 16px solid #f2f8f2;
      border: 16px solid;
      border-image: linear-gradient(10deg, #e6e4dd, #e7ede7, #f1f2f1) 1;
    }
    &.img-group {
      &.letter {
         &:first-child {
          position: relative;
          right: -15px;
        }
        &:not(:first-child) {
          position: relative;
          top: -40px;
          left: -15px;
        }
        &:nth-child(3) {
          position: relative;
          top: -80px;
          left: 15px;
        }
        &:nth-child(4) {
          position: relative;
          top: -110px;
          left: -15px;
          margin-bottom: -30px;
        }
        
      }
      &.phone {
        border-top: 4rem solid rgb(27, 27, 27);
        border-bottom: 4rem solid rgb(27, 27, 27);
        border-left: 2rem solid rgb(27, 27, 27);
        border-right: 2rem solid rgb(27, 27, 27);
        border-radius: 30px;
        position: relative;
      }
      &.screenshots {
        &:first-child {
        position: relative;
        right: -15px;
      }
      &:not(:first-child) {
        position: relative;
        top: -150px;
        left: -15px;
      }
      &:last-child {
        margin-bottom: -90px;
      }
      }

      &.imgs {
        &:first-child {
          position: relative;
          right: -15px;
        }
        &:not(:first-child) {
          position: relative;
          top: -80px;
          left: -15px;
        }
        &:nth-child(3) {
          position: relative;
          top: -180px;
          left: 15px;
          margin-bottom: -90px;
        }
      }
      &.small {
        &:first-child {
          position: relative;
          right: -15px;
        }
        &:not(:first-child) {
          position: relative;
          top: -10px;
          left: -15px;
        }
        &:nth-child(3) {
          position: relative;
          top: -30px;
          left: 15px;
          
        }
        &:nth-child(4) {
          position: relative;
          top: -60px;
          left: -15px;
          margin-bottom: 30px;
        }
      }
      
      
    }
  }

  &-text {
    color: color("white");
    line-height: 1.5em;
    margin: 1.3rem auto 5rem auto;
    width: 90%;
    @include desktop(){
      width: 500px;
    }
  }
  

  &-byline {
    color: color("gray-white");
    line-height: 1.5em;
    font-size: .9em;
    text-align: center;
    margin: 0;
    &.group {
      margin-bottom: 5rem;
    }
    
  }

  .right {
    align-self: flex-end;
    position: relative;
    right: -150px;
    
    @include desktop() {
        right: -150px;
      }
    
    .right-img {
    
      width: 500px;
      @include desktop() {
        width: 660px;
      }
    }
    transform: rotate(-4deg);
  }

  .left {
    align-self: flex-start;
    position: relative;
    left: -60px;
    width: 500px;
    @include desktop() {
      left: -80px;
      width: 660px;
    }
    .left-img {
    
      width: 500px;
      @include desktop() {
        width: 660px;
      }
    }
    transform: rotate(4deg);
  }
}
</style>
